/**
 * useLanding — konten landing yang dikelola owner lewat /admin/settings.
 *
 * Dipakai Footer dan LandingPage sekaligus. Hasilnya di-cache di level modul
 * supaya dua komponen tidak memicu dua request untuk data yang sama.
 */

import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { LandingContent } from "@ag5r-store/shared";

let cache: LandingContent | null = null;
let inflight: Promise<LandingContent> | null = null;

function fetchLanding(): Promise<LandingContent> {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api
      .getLanding()
      .then((d) => {
        cache = d;
        return d;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** Buang cache setelah owner menyimpan perubahan. */
export function invalidateLanding(): void {
  cache = null;
}

export function useLanding() {
  const [data, setData] = useState<LandingContent | null>(cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cache) {
      setData(cache);
      return;
    }
    let cancelled = false;
    fetchLanding()
      .then((d) => { if (!cancelled) setData(d); })
      // Landing tetap harus tampil walau settings gagal dimuat — setiap
      // komponen pemakai punya teks fallback sendiri.
      .catch((e) => { if (!cancelled) setError(e instanceof Error ? e.message : "failed"); });
    return () => { cancelled = true; };
  }, []);

  return { data, error };
}
